import headerScrollWhite from '../partials/headerWhite'
import Swiper from  'swiper'

export default {
  init() {
    window.onscroll = headerScrollWhite;
    $('.management-profiles__tab__button').on('click', function () {
      $(this).parent().parent().toggleClass('active');
    });

    // eslint-disable-next-line
    let timelineMilestones = new Swiper('.timeline-milestones__slider', {
      width: 280,
      spaceBetween: 55,
      freeMode: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      breakpoints: {
        576: {
          width: 357,
        },
      },
    })
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/companyPage.js